import { render } from "./ValueDisplayBox.vue?vue&type=template&id=51412cae&scoped=true"
import script from "./ValueDisplayBox.vue?vue&type=script&lang=js"
export * from "./ValueDisplayBox.vue?vue&type=script&lang=js"

import "./ValueDisplayBox.vue?vue&type=style&index=0&id=51412cae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51412cae"]])

export default __exports__